import { Box, Heading } from 'grommet'
import styled from 'styled-components'

export const Wrapper = styled(Box)`
  margin: ${({ theme }) => theme.spaces[0]} auto;
  margin-bottom: 164px;
  margin-top: 164px;
  max-width: 1050px;
  ${({ theme }) => theme.below.laptop`
   padding: ${theme.spaces[0]}px ${theme.spaces[2]}px
  `}
  ${({ theme }) => theme.below.tablet`
      margin-top: ${theme.spaces[5]}px;
      margin-bottom: ${theme.spaces[5]}px;
  `}
`
export const ContentWrapper = styled(Box)`
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
`
export const BlockWrapper = styled(Box)`
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
  flex-direction: row;
  padding: ${({ theme }) => theme.spaces[3]}px
    ${({ theme }) => theme.spaces[2]}px;
  transition: 0.3s;
  width: 50%;

  ${({ theme }) => theme.below.mobileL`
    width: 100%;
  `}

  ${({ hover }) =>
    hover
      ? `
    &:hover{
      box-shadow: 0px 4px 39px 6px rgba(34, 60, 80, 0.25);
    }
  `
      : ''}

  ${({ uplift }) =>
    uplift
      ? `
    position: relative;
    top: 0;
    transition: top 0.5s ease;
  &:hover{
    top: -20px;
  }`
      : ''}
`
export const Title = styled(Heading)`
  align-items: center;
  display: flex;
  font-size: ${({ theme }) => theme.fontSizes[4]}px;
  font-weight: ${({ theme }) => theme.fontWeight[7]};
  height: 77px;
  line-height: 28px;
  width: 100%;
`
export const Subtitle = styled(Box)`
  color: ${({ theme }) => theme.colors.silver};
  font-weight: ${({ theme }) => theme.fontWeight[2]};
  margin-top: ${({ theme }) => theme.spaces[2]}px;
  max-width: ${({ tableSubtitleWidth }) => tableSubtitleWidth};

  & > a {
    color: ${({ theme }) => theme.colors.primary};
  }

  & > span > a {
    color: ${({ theme }) => theme.colors.primary};
  }

  ${({ theme }) => theme.below.tablet`
    margin-top: ${theme.spaces[0]}px;
  `}

  ${({ theme }) => theme.below.mobileM`
    max-width: 100%;
  `}
`
export const ImageTable = styled(Box)`
  height: ${({ height }) => height.replace('px', '')}px;
  margin-right: ${({ theme }) => theme.spaces[2]}px;
  min-width: ${({ width }) => width.replace('px', '')}px;
  width: ${({ width }) => width.replace('px', '')}px;
  ${({ theme }) => theme.below.tablet`
    height: 50px;
    width: 50px;
  `}

  img {
    object-fit: contain;
  }
`

export const WrapperTitle = styled(Box)`
  max-width: 340px;
`
export const TextWrapper = styled(Box)`
  align-items: center;
  flex-direction: row;
`
